import React from 'react';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import {Permissions} from 'auth/PermissionConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {User} from 'constants/UserConstants';
import {SchemaTag} from 'folder-items/FileConstants';
import ProxyFile from 'folder-items/ProxyFile';
import {DocumentBanner} from 'notebook/components/banners/DocumentBanner';
import {Protocol as ProtocolType} from 'notebook/ELNConstants';
import EditorActions from 'notebook/protocols/actions/EditorActions';
import EditorStore, {ProtocolEditorState} from 'notebook/protocols/stores/EditorStore';

// A proxy model that pulls from the EditorStore

class Protocol extends ProxyFile<ProtocolType, typeof EditorStore> {
  static override initClass(): void {
    this.prototype.proxiedField = 'protocol';
  }

  override getStore(): typeof EditorStore {
    return EditorStore;
  }

  getState(): ProtocolEditorState {
    return this.getStore().getEditorState(this.id)!;
  }

  load({deferred}: {versionId?: number | null; deferred: JQueryDeferred<void>}): void {
    EditorActions.open(this.id, {deferred});
  }

  openLatestVersion(): void {
    EditorActions.open(this.id);
  }

  // TODO T3917: refactor notifications and setBanner to use same text
  override setBanner(): void {
    if (!this.isLatest()) {
      this.setBannerText(
        <DocumentBanner.PreviousVersion
          canEditLatestVersion={this.writable()}
          docType={ModelTypeConstants.PROTOCOL}
          // @ts-expect-error note does not exist on `Protocol`
          isEvaluationPersisted={Boolean(this.proxied()?.note?.noteRuntimeSnapshot?.isEvaluationPersisted)}
          onNavigateToLatest={() => {
            this.openLatestVersion();
          }}
        />
      );
    } else if (!this.writable()) {
      if (this.isArchived()) {
        this.setBannerText(<DocumentBanner.Archived docType={ModelTypeConstants.PROTOCOL} />);
      } else {
        this.setBannerText(<DocumentBanner.ReadOnly docType={ModelTypeConstants.PROTOCOL} />);
      }
    } else {
      this.setBannerText(null);
    }
  }

  override setTags(tags: Array<SchemaTag>): void {
    EditorActions.postServerUpdate(this.id, {tags});
  }

  override setAuthors(authors: Array<User>): void {
    EditorActions.postServerUpdate(this.id, {authors});
  }

  override setArchiveRecord(archiveRecord: ArchiveRecord | null): void {
    EditorActions.postServerUpdate(this.id, {archiveRecord});
  }

  override setPermissions(permissions: Permissions): void {
    EditorActions.postServerUpdate(this.id, {permissions});
  }

  override cleanUp(): void {
    super.cleanUp();
    EditorActions.close(this.id);
  }
}
Protocol.initClass();

export default Protocol;
